import React from 'react';
import styled from 'styled-components';
import type { HTMLAttributes } from 'react';
import type { IconProps } from '../types';
import type { AllColorType, SizeType } from '../../../util/types';
import { ICON_WRAPPER } from '../../../util/data-id';

type Ref = HTMLDivElement;
type HTMLProps = Omit<HTMLAttributes<Ref>, 'color'>;
interface Props extends IconProps, HTMLProps {
  /**
   * Icon wrapper content.
   */
  children: React.ReactNode;
}

const IconWrapper = React.forwardRef<Ref, Props>(
  ({
    color = 'primary',
    size = 'md',
    children,
    ...other
  }: Props, ref) => {
    return (
      <IconWrapperStyled
        ref={ref}
        data-id={ICON_WRAPPER}
        aria-hidden={'true'}
        $color={color}
        $size={size}
        {...(other as HTMLProps)}
      >
        {children}
      </IconWrapperStyled>
    );
  },
);

const IconWrapperStyled = styled('div')<{ $color: AllColorType | null; $size: SizeType | number; }>`
  width: ${(props) => `calc(${!isNaN(parseFloat(props.$size as SizeType)) ? (`${props.$size}px`) : (props.theme.sizes[props.$size])} / 1.5)`};
  height: ${(props) => `calc(${!isNaN(parseFloat(props.$size as SizeType)) ? (`${props.$size}px`) : (props.theme.sizes[props.$size])} / 1.5)`};
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  svg,
  img {
    margin: auto;
    ${(props) => props.$color && `color: ${props.theme.colors[props.$color]};`}
    width: 100%;
    height: 100%;
  }
`;

IconWrapper.displayName = 'IconWrapper';

export default IconWrapper;
